/*A collection of user objects*/
import Team from "@/types/Team/Team";
class TeamList {
    teams = []; // the collection of teams.
    constructor(jsonData) {
        if (jsonData !== null) {
            try {
                jsonData.forEach((team) => {
                    this.teams.push(new Team(team)); //adds a new team to the array
                });
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/TeamList.ts -> constructur');
            }
        }
    }
}
export default TeamList;
